import React, { useEffect, useMemo, useState } from 'react';

export default function CustomerPortal({ user }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        setLoading(true);
        const res = await fetch('/api/get_appointments.php', { credentials: 'include' });
        const data = await res.json();
        const mine = (Array.isArray(data?.appointments) ? data.appointments : []).filter(a => !user?.email || a.email === user.email);
        if (!cancelled) setRows(mine);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [user?.email]);

  const filtered = useMemo(() => {
    return rows.filter((r) => !statusFilter || String(r.status || '').toLowerCase() === statusFilter);
  }, [rows, statusFilter]);

  return (
    <section className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">My Appointments</h1>
        <select className="h-9 px-2 border rounded-md" aria-label="Filter by status" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="">All</option>
          <option value="scheduled">Scheduled</option>
          <option value="completed">Completed</option>
          <option value="canceled">Canceled</option>
          <option value="pending">Pending</option>
        </select>
      </div>

      <div className="rounded-lg border overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <Th>Date</Th>
              <Th>Time</Th>
              <Th>Service</Th>
              <Th>Status</Th>
              <Th className="text-right">Actions</Th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td className="p-3" colSpan={5}>Loading…</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td className="p-3" colSpan={5}>No appointments yet.</td></tr>
            ) : (
              filtered.map((r) => (
                <tr key={`${r.date}_${r.time}`} className="border-t hover:bg-gray-50">
                  <Td>{r.date}</Td>
                  <Td>{r.time}</Td>
                  <Td>{r.service || 'Consultation'}</Td>
                  <Td><Badge>{r.status || 'pending'}</Badge></Td>
                  <Td className="text-right">
                    <button className="text-blue-600 hover:underline mr-3" aria-label={`Reschedule appointment ${r.id || ''}`}>Reschedule</button>
                    <button className="text-red-600 hover:underline" aria-label={`Cancel appointment ${r.id || ''}`}>Cancel</button>
                  </Td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

function Th({ children, className = '' }) {
  return <th className={`p-3 font-medium text-left ${className}`}>{children}</th>;
}

function Td({ children, className = '' }) {
  return <td className={`p-3 align-top ${className}`}>{children}</td>;
}

function Badge({ children }) {
  return <span className="px-2 py-0.5 rounded text-xs bg-gray-100 text-gray-700">{children}</span>;
}
